import React, { Fragment } from 'react';
import { ShipmentStatus } from '../../../../orders/order';

const ShipViaComponent = ({ shipment }) => (
  <Fragment>
    <div className="label">Ship via</div>
    {shipment.status !== ShipmentStatus.Shipped && <span>Best way</span>}
    {shipment.status === ShipmentStatus.Shipped && (
      <div>
        <span>{shipment.freightCarrier.name}</span>
        <br />
        {shipment.trackingNumber && (
          <span>Tracking #{shipment.trackingNumber}</span>
        )}
        {shipment.freightCarrier.supportsOnlineTracking &&
          shipment.fullTrackingUrl && (
            <Fragment>
              <a
                href={shipment.fullTrackingUrl}
                className="ms-2"
                target="_blank"
              >
                Track shipment <i className="fa fa-external-link"></i>
              </a>
            </Fragment>
          )}
      </div>
    )}
  </Fragment>
);

export default ShipViaComponent;
